import { render, staticRenderFns } from "./DashboardFTable.vue?vue&type=template&id=5907aebe&"
import script from "./DashboardFTable.vue?vue&type=script&lang=js&"
export * from "./DashboardFTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports